// api/contactActions.ts

import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com";

const BASE_URL = `${API_BASE_URL}/contact`;

// ==========================
// 📞 GET CONTACTS BY CLIENT
// ==========================
export const getContactsByClientApi = async (
  client_id: number
) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/by-client`,
      {
        params: { client_id },
      }
    );

    return res.data;
  } catch (error: any) {
    return {
      status: false,
      contacts: [],
      message:
        error.response?.data?.message ||
        "Failed to fetch client contacts",
    };
  }
};

// ==========================
// 📞 GET ALL CONTACTS
// ==========================
export const getAllContactsApi = async () => {
  try {
    const res = await axios.get(`${BASE_URL}/`);
    return res.data;
  } catch (error: any) {
    return {
      status: false,
      contacts: [],
      message:
        error.response?.data?.message ||
        "Failed to fetch contacts",
    };
  }
};

// ==========================
// ➕ ADD NEW CONTACT
// ==========================
export const addContactApi = async (
  contactData: FormData | Record<string, any>
) => {
  try {
    const isFormData =
      contactData instanceof FormData;

    const res = await axios.post(
      `${BASE_URL}/`,
      contactData,
      {
        headers: isFormData
          ? {
              "Content-Type":
                "multipart/form-data",
            }
          : {
              "Content-Type":
                "application/json",
            },
      }
    );

    return res.data;
  } catch (error: any) {
    return {
      status: false,
      message:
        error.response?.data?.message ||
        "Failed to add contact",
    };
  }
};

// ==========================
// ✏️ UPDATE CONTACT
// ==========================
export const updateContactApi = async (
  id: number,
  contactData: FormData | Record<string, any>
) => {
  try {
    const isFormData =
      contactData instanceof FormData;

    const res = await axios.put(
      `${BASE_URL}/${id}`,
      contactData,
      {
        headers: isFormData
          ? {
              "Content-Type":
                "multipart/form-data",
            }
          : {
              "Content-Type":
                "application/json",
            },
      }
    );

    return res.data;
  } catch (error: any) {
    return {
      status: false,
      message:
        error.response?.data?.message ||
        "Failed to update contact",
    };
  }
};

// ==========================
// 🗑️ DELETE CONTACT
// ==========================
export const deleteContactApi = async (
  id: number
) => {
  try {
    const res = await axios.delete(
      `${BASE_URL}/${id}`
    );

    return res.data;
  } catch (error: any) {
    return {
      status: false,
      message:
        error.response?.data?.message ||
        "Failed to delete contact",
    };
  }
};

// ==========================
// 📦 ADD BULK CONTACTS TO GROUP
// ==========================
export const addBulkContactsToGroupApi = async (
  payload: {
    contact_ids: number[];
    group_id: number;
  }
) => {
  try {
    const res = await axios.post(
      `${BASE_URL}/add-bulk-to-group`,
      payload
    );

    return res.data;
  } catch (error: any) {
    return {
      status: false,
      message:
        error.response?.data?.message ||
        "Failed to add contacts to group",
    };
  }
};

// ==========================
// 🔍 GET CONTACT DETAILS
// ==========================
export const getContactDetailsApi = async (
  params: {
    contact_id?: number;
    contact_mobile?: string;
  }
) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/get_contact_details`,
      {
        params,
      }
    );

    return res.data;
  } catch (error: any) {
    return {
      status: false,
      message:
        error.response?.data?.message ||
        "Failed to fetch contact details",
    };
  }
};

// ==========================
// 👤 GET CONTACT PROFILE
// ==========================
export const getContactProfileApi = async (
  params: {
    contact_id?: number;
    contact_mobile?: string;
  }
) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/profile`,
      {
        params,
      }
    );

    return res.data;
  } catch (error: any) {
    return {
      status: false,
      message:
        error.response?.data?.message ||
        "Failed to fetch contact profile",
    };
  }
};

// ==========================
// 🏷️ GET CONTACT DESIGNATIONS & GROUPS
// ==========================
export const getContactDesignationsAndGroupsApi = async (
  contact_id: number
) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/designations`,
      {
        params: { contact_id },
      }
    );

    return res.data;
  } catch (error: any) {
    return {
      status: false,
      message:
        error.response?.data?.message ||
        "Failed to fetch designations and groups",
    };
  }
};